import { FlexCenter } from "@9amhealth/shared";
import { NineFunnelStep } from "@9amhealth/wcl/generated/react";
import type { FC } from "react";
import React, { useCallback } from "react";
import { userEmailVerificationState, userState } from "src/state/state";
import EmailVerificationStep from "src/ui/components/RegisterForm/EmailVerificationStep";
import type { SignupCustomStepProps } from "src/ui/components/SignupCustomContent/RenderSignupCustomStep";
import {
  SignupCustomStepType,
  type SignupCustomStepEmailVerification as SignupCustomStepEmailVerificationType
} from "src/ui/components/SignupCustomContent/SignupCustom.types";

const funnelStepStyle = {
  padding: "var(--funnel-step-padding, 4rem var(--space-md))",
  "--funnel-step-min-height": "auto",
  minHeight: "auto"
} as React.CSSProperties;

const SignupCustomStepEmailVerificationContent: FC<SignupCustomStepProps> = ({
  step,
  onStepCompleted
}) => {
  const verificationToken = userEmailVerificationState.verificationToken ?? "";

  const typedStep = step as SignupCustomStepEmailVerificationType;
  const email =
    typedStep.emailVerificationPageProps?.email ??
    userState.state.userData?.email ??
    "";

  const handleSuccess = useCallback(() => {
    userEmailVerificationState.clearVerificationToken();
    void onStepCompleted(step);
  }, [onStepCompleted, step]);

  return (
    <NineFunnelStep center="true" style={funnelStepStyle}>
      <FlexCenter style={{ minHeight: "auto" }}>
        <EmailVerificationStep
          email={email}
          verificationToken={verificationToken}
          onSuccess={handleSuccess}
        />
      </FlexCenter>
    </NineFunnelStep>
  );
};

const SignupCustomStepEmailVerification: FC<SignupCustomStepProps> = React.memo(
  (props) => {
    const isEmailVerificationStep =
      props.step.type === SignupCustomStepType.EmailVerification;
    return isEmailVerificationStep ? (
      <SignupCustomStepEmailVerificationContent
        onStepCompleted={props.onStepCompleted}
        step={props.step}
      />
    ) : null;
  }
);

export default SignupCustomStepEmailVerification;
